import mixpanel from "mixpanel-browser";
import React from "react";

import { handleSubscribe } from "../../../../../api/Billing";
import { UNLIMITED_PRICE_ID_MONTHLY } from "../../../../../constants";
import { BasicButton } from "../../../../common/buttons/BasicButton";

export default function ClientSummaryFreePlanState({ noteUuid }) {
  const handleUpgrade = () => {
    handleSubscribe({
      priceId: UNLIMITED_PRICE_ID_MONTHLY,
      route: `/edit_note/${noteUuid}`,
    });
    mixpanel.track("Upgrade Plan Clicked", {
      featureName: "Client Summary",
    });
  };
  return (
    <div className="flex flex-col items-center justify-center p-6 space-y-2 bg-gray-50 dark:bg-gray-800 rounded-lg">
      <h3 className="text-xl font-semibold">
        Upgrade to Access Client Summaries
      </h3>
      <p className="text-gray-600 dark:text-gray-400 mb-2">
        Generate clear, concise summaries for your clients
        automatically from your notes.
      </p>
      <div className="w-full max-w-2xl aspect-video">
        <iframe
          className="w-full h-full rounded-lg"
          src="https://www.youtube.com/embed/OW6zCSwIooI"
          title="Client Summary Demo"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>

      <div className="text-center max-w-xl mt-4">
        <BasicButton
          onClick={handleUpgrade}
          importance="primary"
          type="button"
        >
          Get Access to Client Summaries
        </BasicButton>
      </div>
    </div>
  );
}
